/**
 * Preview container (real material render button, shapejs viewer, slideshow) autohandler
 *
 * Usage:
 *
 * data-sw-preview-container=<productSpin>
 *
 */

var $ = require('js/sw-jquery/sw-jquery');
var PreviewContainer = require('js/lib/views/PreviewContainer');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-preview-container]').each(function() {
    var $el = $(this);

    require(['js/lib/models/ModelManager'], function(ModelManager) {
      var spin = $el.data('swPreviewContainer');
      var product = ModelManager.getProduct(spin);
      var shapeJsViewerName = $el.data('swPreviewContainerShapejsViewerName');

      new PreviewContainer({
        el:     $el,
        model:  product,
        shapeJsId: shapeJsViewerName
      });
    });
  });

};
